import {
    Button,
    Form,
    message,
    Skeleton
} from "antd";
import { FC, useCallback, useEffect, useLayoutEffect, useState } from "react";
import { useTranslation } from "react-i18next";

//!STYLES
import * as AUTH_SERVICES from "api/services/auth/auth.services";
import { getTimeZonesByCountryCode, StatusCode } from "common/enums";
import * as appRoutes from "config/routes.config";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { updateUser } from "store/auth/authSlice";
import TimeZoneList from "../components/TimeZoneList";
import st from "./assets/register.module.css";

import { API_RESSOURCES } from "api/services/teacher/teacher.routes";
import axios, { AxiosResponse } from "axios";
import { displayDrawer } from "store/adventissements";
import TeacherPicture from "../../../assets/images/teacher/teacher.svg";

import { setUserHavingCalendar } from "store/app/appSlice";
import CheckIcon from "../../../assets/images/app/checkAlert.svg";


type Props = {
    stepSevenData: any;
    setCurrent: React.Dispatch<React.SetStateAction<number>>;
};

interface CustomResponse {
    statusCode: number;
    message: string;
    data: any;
}

const StepEight: FC<Props> = ({ stepSevenData, setCurrent }) => {
    //!HOOKS
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { user } = useSelector((state) => state.auth);
    const navigate = useNavigate();
    const [formInfos] = Form.useForm();

    //!STATES
    const [isChecking, setIsChecking] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [isCalendar, setIsCalendar] = useState<boolean>(false);
    const [profilePreview, setProfilePreview] = useState('');
    const { isCalendarUpdated } = useSelector((state) => state.app);

    //!CONSTANTS
    const validateMessages = {
        required: t("auth.error.required"),
        types: {
            email: t("auth.error.emailInvalid"),
        },
    };

    //!STATES JOFREY
    const [stepTwoData, setStepTwoData] = useState<any>({});

    //!FUNCTIONS JOFREY
    const endRegistation = async (values: any) => {
        setIsLoading(true);
        const finalData = {
            fuseauHorraire: values.fuseauHorraire,
            step: "completed",
        };

        try {
            const response = await AUTH_SERVICES.updateTeacher(user?._id, {
                ...finalData,
            });
            if (response?.statusCode === StatusCode.OK) {
                message.success({
                    content: "Modification effectuée ",
                });
                dispatch(
                    updateUser({ ...user, fuseauHorraire: values.fuseauHorraire, step: "completed" })
                );
            }
            else {
                message.warning({
                    content: "une erreur est survenue",
                });
            }
        } catch (error: any) {
            let content = "";
            for (
                let index = 0;
                index < error?.response?.data?.message?.length;
                index++
            ) {
                content = error?.response?.data?.message[index] + ", " + content;
            }
            message.error({
                content: content,
            });
        } finally {
            setIsLoading(false);
            navigate(user?.firstLogin ? appRoutes.ONBOARDING : appRoutes.TEACHER_ACTIVITIES);
        }
    };

    const passUpdateProfile = async () => {
        setIsLoading(true);
        const countryCode = localStorage.getItem("countryCode");
        if (countryCode) {
            console.log(countryCode);
            const fuseauHorraire = getTimeZonesByCountryCode(countryCode);
            console.log(fuseauHorraire);
            const finalData = {
                fuseauHorraire: fuseauHorraire,
                step: "completed",
            };
            try {
                const response = await AUTH_SERVICES.updateTeacher(user?._id, {
                    ...finalData,
                });
                if (response?.statusCode === StatusCode.OK) {
                    message.success({
                        content: "Modification effectuée ",
                    });
                    dispatch(
                        updateUser({ ...user, fuseauHorraire: fuseauHorraire, step: "completed" })
                    );
                }
                else {
                    message.warning({
                        content: "une erreur est survenue",
                    });
                }
            } catch (error: any) {
                let content = "";
                for (
                    let index = 0;
                    index < error?.response?.data?.message?.length;
                    index++
                ) {
                    content = error?.response?.data?.message[index] + ", " + content;
                }
                message.error({
                    content: content,
                });
            } finally {
                setIsLoading(false);
                navigate(user?.firstLogin ? appRoutes.ONBOARDING : appRoutes.TEACHER_ACTIVITIES);
            }
        }
        else {
            const fuseauHorraire = getTimeZonesByCountryCode("FR");
            const finalData = {
                fuseauHorraire: fuseauHorraire,
                step: "completed",
            };
            try {
                const response = await AUTH_SERVICES.updateTeacher(user?._id, {
                    ...finalData,
                });
                if (response?.statusCode === StatusCode.OK) {
                    message.success({
                        content: "Modification effectuée ",
                    });
                    dispatch(
                        updateUser({ ...user, fuseauHorraire: fuseauHorraire, step: "completed" })
                    );
                }
                else {
                    message.warning({
                        content: "une erreur est survenue",
                    });
                }
            } catch (error: any) {
                let content = "";
                for (
                    let index = 0;
                    index < error?.response?.data?.message?.length;
                    index++
                ) {
                    content = error?.response?.data?.message[index] + ", " + content;
                }
                message.error({
                    content: content,
                });
            } finally {
                setIsLoading(false);
                navigate(user?.firstLogin ? appRoutes.ONBOARDING : appRoutes.TEACHER_ACTIVITIES);
            }
        }

    }

    const fetchCalender = useCallback(async (idTeacher: string) => {
        const startDate = new Date().toISOString().split("T")[0];
        try {
            setIsChecking(true);
            const response: AxiosResponse<CustomResponse> = await axios.get(`${API_RESSOURCES}/advertisements/fetch/ReelCalender/prof/instance/${idTeacher}`, {
                params: { startDate },
            });
            if (response.status === StatusCode.OK) {
                if (response?.data?.data) {
                    dispatch(setUserHavingCalendar(true));
                    setIsCalendar(true);
                }
                else {
                    dispatch(setUserHavingCalendar(false));
                    setIsCalendar(false);
                }
            }
            else {
                dispatch(setUserHavingCalendar(false));
                setIsCalendar(false);
            }
        } catch (error) {
            dispatch(setUserHavingCalendar(false));
            setIsCalendar(false);
        }
        finally {
            setIsChecking(false);
        }
    },
        [user?._id]
    );

    //!EFFECTS
    useEffect(() => {
        if (user) {
            if (user?.fuseauHorraire !== '') {
                formInfos.setFieldsValue({
                    fuseauHorraire: user?.fuseauHorraire,
                });
            }
        }
    }, [user, formInfos]);

    useLayoutEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const [teacherData, setTeacherData] = useState<any>();

    const getTeacherData = async (teacherId: string) => {
        try {
            const response = await AUTH_SERVICES.getTeacherData(user?._id, teacherId);
            setTeacherData(response?.data);
        } catch (error: any) { }
    };

    useEffect(() => {
        getTeacherData(user?._id);
    }, []);

    useEffect(() => {
        if (user) {
            setProfilePreview(user?.profile);
        }
    }, [user]);

    useEffect(() => {
        fetchCalender(user?._id);
    }, [user]);

    useEffect(() => {
        fetchCalender(user?._id);
    }, [isCalendarUpdated]);

    return (
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", width: "100%", height: "100%", textAlign: "center" }}>
            <div className={st.avatarBox}>
                {profilePreview !== "" ? <img src={profilePreview} alt="Uploaded Preview" height={140} style={{ borderRadius: "50%" }}></img> : <img src={TeacherPicture} height={140}></img>}
            </div>
            <p className={st.pageTitle}>Programme et disponibilités</p>
            <Form
                validateTrigger={["onFinish"]}
                name="registerTeacher"
                autoComplete="off"
                form={formInfos}
                validateMessages={validateMessages}
                onFinish={endRegistation}
            >
                <div className={st.HoursBox}>
                    <div className={st.titleDescriptionBox}>
                        Choisis ton fuseau horaire
                        <span>Il est essentiel d’être sur le bon fuseau horaire pour coordonner<br />les leçons avec les élèves à l’international.</span>
                    </div>
                    <div className={st.calendarTimezone}>
                        <TimeZoneList />
                    </div>
                </div>

                <div className={st.HoursBox}>
                    {isChecking ? <Skeleton></Skeleton> : <div className={st.titleDescriptionBox}>
                        <div className={st.calendarAvailability}>Mes disponibilités {isCalendar && <img src={CheckIcon} height={15} style={{ marginLeft: "5px" }}></img>}</div>
                        <span>Crée ton calendrier de disponibilités pour donner des cours. </span>
                        <span>Tu peux aussi le remplir plus tard.</span>
                    </div>}
                    {isChecking ? <Skeleton></Skeleton> : <Button className={st.calendarButton} style={{ marginTop: "10px" }} onClick={() => dispatch(displayDrawer(true))}>{isCalendar ? "Gérer mes disponibilités" : "Ajouter mes disponibilités"}</Button>}
                </div>

                <div className={st.rowsButtons}>
                    <Button onClick={() => setCurrent((n) => n - 1)} className={st.newMoveButton}>Retour</Button>
                    <Form.Item style={{ marginTop: "10px", marginBottom: "10px", padding: 0 }}>
                        <Button loading={isLoading} htmlType="submit" className={st.newActionButton}>Terminer</Button>
                    </Form.Item>
                    <Button loading={isLoading} onClick={passUpdateProfile} className={st.newMoveButton}>Remplir plus tard</Button>
                </div>

            </Form>
        </div>
    );
};

export default StepEight;
